export const translationKeys = {
  ariaLabel: 'hamburgerOpenButton_ariaLabel',
};
